import { render, staticRenderFns } from "./CreateMailing.vue?vue&type=template&id=3c5810d4&scoped=true&"
import script from "./CreateMailing.vue?vue&type=script&lang=js&"
export * from "./CreateMailing.vue?vue&type=script&lang=js&"
import style0 from "./CreateMailing.vue?vue&type=style&index=0&id=3c5810d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5810d4",
  null
  
)

export default component.exports